import {useQuery} from '@tanstack/react-query';
import {categoryGroupsApi} from '../api';

interface UseCategoryGroupsWithCategoriesOptions {
  enabled?: boolean;
}

export const useCategoryGroupsWithCategories = ({
  enabled = true,
}: UseCategoryGroupsWithCategoriesOptions = {}) => {
  return useQuery({
    queryKey: ['categoryGroupsWithCategories'],
    queryFn: categoryGroupsApi.getCategoryGroupsWithCategories,
    staleTime: 60 * 1000,
    enabled,
  });
};
